module.exports = __webpack_public_path__ + "static/media/offroad.b0712ac4.svg";